class RomanConverter {
  // A szám és a hozzá tartozó római megfelelő
  static romanMap = [
    { value: 1000, numeral: "M" },
    { value: 900, numeral: "CM" },
    { value: 500, numeral: "D" },
    { value: 400, numeral: "CD" },
    { value: 100, numeral: "C" },
    { value: 90, numeral: "XC" },
    { value: 50, numeral: "L" },
    { value: 40, numeral: "XL" },
    { value: 10, numeral: "X" },
    { value: 9, numeral: "IX" },
    { value: 5, numeral: "V" },
    { value: 4, numeral: "IV" },
    { value: 1, numeral: "I" }
  ];

  static convert(number) {
    if (number <= 0 || number >= 4000) {
      throw new Error("A számnak 1 és 3999 között kell lennie. ['"+number+"']");
    }

    let result = "";
    let remaining = number;

    for (const { value, numeral } of RomanConverter.romanMap) {
      while (remaining >= value) {
        result += numeral;
        remaining -= value;
      }
    }

    return result;
  }
}

export default RomanConverter;
